(function () {
  function closestRoot(el) {
    return el && el.closest && el.closest("[data-amateur-take-root]");
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function setupReadMore(body) {
    if (!body || body.dataset.amateurTakeReadMoreInit === "true") return;
    body.dataset.amateurTakeReadMoreInit = "true";

    var lines = parseInt(body.getAttribute("data-line-limit"), 10) || 2;
    if (lines < 1) lines = 2;

    var fullHtml = body.innerHTML;
    var words = (body.textContent || "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) return;

    var readMoreLabel = body.getAttribute("data-read-more-label") || "Read more";
    var readLessLabel = body.getAttribute("data-read-less-label") || "Read less";
    var btnHtml =
      '<button type="button" class="am-amateur-take__read-more-btn" aria-expanded="false" aria-label="' +
      escapeHtml(readMoreLabel) +
      '">' +
      '<span class="am-amateur-take__ellipsis" aria-hidden="true">… </span>' +
      '<span class="am-amateur-take__read-more-label">' +
      escapeHtml(readMoreLabel) +
      "</span>" +
      "</button>";

    var root = body.closest(".am-amateur-take");
    var stage = root && root.querySelector(".am-amateur-take__stage");
    var width = Math.max(
      body.clientWidth,
      body.getBoundingClientRect().width,
      stage ? stage.clientWidth : 0,
      root ? root.clientWidth : 0,
      0
    );
    // Avoid clamping against a collapsed width (would leave ~1 word)
    if (width < 40) {
      delete body.dataset.amateurTakeReadMoreInit;
      requestAnimationFrame(function () {
        setupReadMore(body);
      });
      return;
    }

    // Probe under .am-amateur-take so font/size cascade matches, using the same clamped markup
    var probe = document.createElement("div");
    probe.className = body.className;
    probe.setAttribute(
      "style",
      "position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;z-index:-1;" +
        "width:" +
        width +
        "px;",
    );
    (root || document.body).appendChild(probe);

    function renderClamped(innerHtml) {
      probe.innerHTML =
        '<div class="am-amateur-take__read-more am-amateur-take__read-more--clamped">' +
        '<p class="am-amateur-take__preview-line">' +
        innerHtml +
        "</p></div>";
    }

    function countWrappedLines(el) {
      if (!el) return 0;
      var range = document.createRange();
      range.selectNodeContents(el);
      var rects = range.getClientRects();
      var tops = {};
      var count = 0;
      for (var r = 0; r < rects.length; r++) {
        var key = Math.round(rects[r].top);
        if (!tops[key]) {
          tops[key] = true;
          count += 1;
        }
      }
      return count;
    }

    // Count full preview lines (text + “… read more”) so the CTA stays on line 2
    function lineCountFor(wordCount) {
      var slice = words.slice(0, wordCount).join(" ");
      renderClamped(
        '<span class="am-amateur-take__preview-text">' +
          escapeHtml(slice) +
          "</span>" +
          btnHtml
      );
      return countWrappedLines(probe.querySelector(".am-amateur-take__preview-line"));
    }

    // If full text + inline button already fits in N lines, leave original content alone
    if (lineCountFor(words.length) <= lines) {
      probe.remove();
      return;
    }

    var lo = 1;
    var hi = words.length - 1;
    var best = 1;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (lineCountFor(mid) <= lines) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }
    // Final shrink if “read more” still drops to line 3
    while (best > 1 && lineCountFor(best) > lines) best -= 1;
    probe.remove();

    var truncated = words.slice(0, best).join(" ");

    var EASE = "cubic-bezier(0, 0, 0.2, 1)";
    var MS = 300;
    var TRANS = "max-height " + MS + "ms " + EASE;

    var wrapper = document.createElement("div");
    wrapper.className = "am-amateur-take__read-more am-amateur-take__read-more--clamped";

    var panel = document.createElement("div");
    panel.className = "am-amateur-take__read-more-panel";

    var previewLine = document.createElement("p");
    previewLine.className = "am-amateur-take__preview-line";

    var textSpan = document.createElement("span");
    textSpan.className = "am-amateur-take__preview-text";
    textSpan.textContent = truncated;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "am-amateur-take__read-more-btn";
    btn.innerHTML =
      '<span class="am-amateur-take__ellipsis" aria-hidden="true">… </span>' +
      '<span class="am-amateur-take__read-more-label">' +
      escapeHtml(readMoreLabel) +
      "</span>";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", readMoreLabel);

    var full = document.createElement("div");
    full.className = "am-amateur-take__full rte";
    full.innerHTML = fullHtml;
    full.hidden = true;

    function clearPanelAnim(el) {
      if (el._amTakeFallback) {
        clearTimeout(el._amTakeFallback);
        el._amTakeFallback = null;
      }
      if (el._amTakeEnd) {
        el.removeEventListener("transitionend", el._amTakeEnd);
        el._amTakeEnd = null;
      }
    }

    function setExpandedUi(expanded) {
      if (expanded) {
        wrapper.classList.remove("am-amateur-take__read-more--clamped");
        wrapper.classList.add("am-amateur-take__read-more--expanded");
        previewLine.hidden = true;
        full.hidden = false;
        panel.appendChild(btn);
        btn.innerHTML =
          '<span class="am-amateur-take__read-more-label">' +
          escapeHtml(readLessLabel) +
          "</span>";
        btn.setAttribute("aria-expanded", "true");
        btn.setAttribute("aria-label", readLessLabel);
      } else {
        wrapper.classList.add("am-amateur-take__read-more--clamped");
        wrapper.classList.remove("am-amateur-take__read-more--expanded");
        previewLine.hidden = false;
        full.hidden = true;
        previewLine.appendChild(btn);
        btn.innerHTML =
          '<span class="am-amateur-take__ellipsis" aria-hidden="true">… </span>' +
          '<span class="am-amateur-take__read-more-label">' +
          escapeHtml(readMoreLabel) +
          "</span>";
        btn.setAttribute("aria-expanded", "false");
        btn.setAttribute("aria-label", readMoreLabel);
      }
    }

    function animateReadMore(expand) {
      clearPanelAnim(panel);
      var startH = panel.offsetHeight || panel.scrollHeight;
      panel.style.overflow = "hidden";
      panel.style.transition = "none";
      panel.style.maxHeight = startH + "px";
      void panel.offsetHeight;

      var endH;

      if (expand) {
        setExpandedUi(true);
        panel.style.maxHeight = "none";
        endH = panel.scrollHeight;
        panel.style.maxHeight = startH + "px";
        void panel.offsetHeight;

        panel.style.transition = TRANS;
        panel.style.maxHeight = endH + "px";
      } else {
        // Keep full copy visible; measure clamped height, then shrink
        setExpandedUi(false);
        endH = panel.scrollHeight;
        setExpandedUi(true);
        panel.style.maxHeight = startH + "px";
        void panel.offsetHeight;

        panel.style.transition = TRANS;
        panel.style.maxHeight = endH + "px";
      }

      var done = function (e) {
        if (e && e.propertyName && e.propertyName !== "max-height") return;
        clearPanelAnim(panel);
        if (!expand) setExpandedUi(false);
        panel.style.maxHeight = "none";
        panel.style.overflow = "";
        panel.style.transition = "";
      };
      panel._amTakeEnd = done;
      panel._amTakeFallback = setTimeout(done, MS + 40);
      panel.addEventListener("transitionend", done);
    }

    btn.addEventListener("click", function () {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      animateReadMore(!expanded);
    });

    previewLine.appendChild(textSpan);
    previewLine.appendChild(btn);
    panel.appendChild(previewLine);
    panel.appendChild(full);
    wrapper.appendChild(panel);

    body.innerHTML = "";
    body.appendChild(wrapper);
    body.classList.add("am-amateur-take__panel-body--truncated");
  }

  function initReadMore(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-amateur-take-body]").forEach(setupReadMore);
  }

  function syncCollapsibleHeight(el, collapse) {
    if (!el) return;
    if (collapse) {
      el.style.maxHeight = "0px";
      return;
    }
    el.style.maxHeight = el.scrollHeight + "px";
  }

  function syncHeights(root) {
    var base = root.querySelector("[data-amateur-take-base]");
    var openPanel = root.querySelector("[data-amateur-take-open-panel]");
    var isOpen = root.classList.contains("am-amateur-take--open");
    var isTake2 = root.classList.contains("am-amateur-take--toggle-below");

    if (isTake2) {
      if (base) base.style.maxHeight = base.scrollHeight + "px";
      syncCollapsibleHeight(openPanel, isOpen);
      return;
    }

    if (!base) return;
    syncCollapsibleHeight(base, isOpen);
  }

  function setOpen(root, open) {
    if (!root) return;
    root.classList.toggle("am-amateur-take--open", open);
    var btn = root.querySelector("[data-amateur-take-toggle]");
    if (btn) {
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    }
    var panel = root.querySelector("[data-amateur-take-panel]");
    if (panel) {
      panel.setAttribute("aria-hidden", open ? "false" : "true");
    }
    syncHeights(root);
  }

  function toggle(root) {
    var open = !root.classList.contains("am-amateur-take--open");
    setOpen(root, open);
  }

  function bindRoot(root) {
    syncHeights(root);
    if (typeof ResizeObserver !== "undefined") {
      var targets = root.querySelectorAll(
        "[data-amateur-take-base], [data-amateur-take-open-panel]"
      );
      var ro = new ResizeObserver(function () {
        syncHeights(root);
      });
      targets.forEach(function (el) {
        ro.observe(el);
      });
    } else {
      window.addEventListener("resize", function () {
        syncHeights(root);
      });
    }
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest("[data-amateur-take-toggle]");
    if (!btn) return;
    var root = closestRoot(btn);
    if (!root) return;
    e.preventDefault();
    toggle(root);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest("[data-amateur-take-toggle]");
    if (!btn || document.activeElement !== btn) return;
    var root = closestRoot(btn);
    if (!root) return;
    e.preventDefault();
    toggle(root);
  });

  function initRoot(root) {
    var open = root.classList.contains("am-amateur-take--open");
    setOpen(root, open);
    bindRoot(root);
    root.classList.add("am-amateur-take--ready");
    // Wait a frame so widths are resolved before measuring the 2-line clamp
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        initReadMore(root);
        syncHeights(root);
      });
    });
  }

  document.querySelectorAll("[data-amateur-take-root]").forEach(initRoot);
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      initReadMore();
    });
  });

  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-amateur-take-root]").forEach(initRoot);
    requestAnimationFrame(function () {
      initReadMore(e.target);
    });
  });
})();
